import React, { useState, useEffect, useContext } from "react";
// import axios from "axios";
import QRCodeStyling, { gradientTypes } from "qr-code-styling";
import QRCodeForm from "./qrForm/QRCodeForm";
import Qr from "./QR";
import GeneratedQR from './GeneratedQR'
import ManagerQR from './ManagerQR'
import QR from './QR'
import { QRCodeContext } from "../context/QRCodeProvider";
import { AppContext } from "../context/AppProvider";
import { Button, Container, Stack, TextField } from "@mui/material";
import CloseButton from "./CloseButton";
import QRFraming from "./QRFraming";

import * as API from '../utils/APICalls'
import * as helpers from '../utils/helpers'

// const Default_QR = require('../options_02.json')
const Default_QR = require('../defaults/QRRough.json')



const CreateQR = ({ view, user }) => {
  // const view = props.view
  const { qrCodeData, setQRCodeData, updateQRCodeData, defaultQR } = useContext(QRCodeContext);
  const { appData, updateAppData, setPreviewQR, previewQR, selectedQR, setSelectedQR,
    modalOpen, currentAsset, setCurrentAsset, setActionError, actionError } = useContext(AppContext);
  const [QRName, setQRName] = useState('')
  const [QRIcon, setQRIcon] = useState('')
  const [qrTop, setQrTop] = useState(true)
  const data_default = 'https://qaura.pro/assets/00000001'
  const [loading, setLoading] = useState(false)
  const [isSavingQR, setIsSavingQR] = useState(false)
  const [confirmNext, setConfirmNext] = useState()

  const handleQRCreate = async (e) => {
    e.preventDefault()
    setIsSavingQR(true)
    try {
      const hexString = await helpers.generateRandomHex(6);

      const data = await API.createQR({
        ...Default_QR,
        owner: user?._id,
        name: QRName,// currentOrder?.itemName + ' Asset - ',
        //   data: `https://qaura.pro/assets/${qrCodeData?._id}`,
        image: QRIcon,
        pin: hexString,
        payload: 'New QR. Please activate.'
      })
      console.log('[handleQRCreate] data:', data)
      if (data?.owner) {
        try {

          updateQRCodeData(data)
          // setSelectedQR(data)

          // const baseQR = await saveBaseQRImage(data)


          // console.log('[handleQRCreate] baseQR:--->', baseQR)
          setActionError('')
          // setQRName('')
          // updateAppData({
          //   modalOpen: false,
          //   modalView: ''
          // })

        } catch (err) {
          setActionError('Error Creating Qr')
          console.log('[handleQRCreate] Error:', err)
        }

      }

      setLoading(false);
      setConfirmNext(true)
    } catch (err) { console.log('[saveBaseQRImage]----[Error]', err) }
    setIsSavingQR(false)
  }

  const handleNameChange = (e) => {
    try {
      setQRName(e.target.value)
    } catch (err) {
      console.log(err)
    }
  }
  const handleIconChange = (e) => {
    try {
      setQRIcon(e.target.value)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {

    updateQRCodeData({})


  }, [modalOpen])

  useEffect(() => {




  }, [confirmNext, qrCodeData])

  useEffect(() => {
    const populateQR = () => {
      try {

        // updateQRCodeData({})
        // if (!qrCodeData) {

        // updateQRCodeData({})
        // if (view === 'create-QR') {
        //   console.log('view === create-QR')
        //   updateQRCodeData({ ...defaultQR })
        // }
        if (view === 'edit-QR') {
          // updateQRCodeData({})
          console.log('view === edit-QR')
          updateQRCodeData({ ...selectedQR })
        }
        // }
      } catch (err) {
        console.log('Error Populating QR:', err)
      }
    }
    populateQR()
    // setSelectedQR({...qrCodeData})

  }, [])
  useEffect(() => {

  }, [qrCodeData])


  return (
    <Container style={{
      // height: '100%', 
      display: 'flex',
      flexDirection: 'column',
      // height: '90%',
      minHeight: '70vh', width: '100%', maxWidth: '800px',
      minWidth: '375px', borderRadius: '10px', margin: 'auto',
      backgroundImage: "url('/assets/bodybg.png')",
      padding: '1rem',
      backgroundAttachment: 'fixed',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'cover', flex: 1
    }} >
      <div style={{
        position: 'absolute', top: 0, left: 0,
        width: '100%', height: '3rem', padding: '0.5rem',
        backgroundColor: '#fff', marginBottom: '1rem',
        borderBottom: '2px solid #000',
        boxShadow: '0px 0px 5px 2px rgba( 0, 0, 0,0.5)'
      }}>

        <h2>{view === 'create-QR' ? 'Create' : 'Edit'} a QR</h2>
        <div style={{ position: 'absolute', top: '0.5rem', right: '1.5rem', zIndex: 9999 }}>
          <CloseButton func={updateAppData} view='dash' val={{
            modalOpen: false,
            modalView: ''
          }} />
        </div>
      </div>
      {/* <section className="QR-frame" 
      style={{ display: 'flex',position: 'relative', height:'40vh', 
      minHeight:'250px',zIndex: qrTop ? 1000 : 1, alignItems: 'center' }} 
        onClick={(e)=>{
          console.log('section click: ', e.target.style)
          setQrTop(true)}}>


          {!qrTop && <b className="blink-2" style={{fontSize:'0.85rem', width:'100%', position:'absolute',top:'0.5rem',left:'1.5rem', zIndex:999999}}>click to bring to front</b>}
        {/* <ManagerQR QR={view === 'edit-QR'? selectedQR : qrCodeData } view={view} key={view}/>  */}
      {/* <QR QR={view === 'edit-QR'? selectedQR : defaultQR } view={view} key={view}/>  */}
      {/* </section>  */}
      <Stack style={{
        alignSelf: 'center',
        gap: '0.5rem', position: 'relative',
        marginTop: '2rem', zIndex: qrTop ? 1 : 1000, height: '100%',
        // border: '2px solid #000',
        margin: 'auto',
        width: '100%'

      }} onClick={() => { setQrTop(false) }}>
        {/* {qrCodeData?._id && <QRFraming view={view} />} */}
        <QRFraming view={view} />
        {view === 'create-QR' && !qrCodeData?._id && <Stack sx={{
          gap: '0.5rem', padding: '1rem', margin: 'auto',
          width: '80%',
          borderRadius: '5px',
          border: '2px solid #000',
          backgroundColor: 'rgba(255,255,255,0.7)'
        }}>

          {/* {qrTop && <b className="blink-2" style={{ fontSize: '0.85rem', width: '100%', position: 'absolute', bottom: '0.5rem', left: '1.5rem', zIndex: 999999 }}>click to bring to front</b>} */}

          {/* <QRCodeForm view={view} /> */}
          <TextField label='QR Name' sx={{ width: '70%' }}
            value={QRName}
            onChange={(e) => handleNameChange(e)}
          >

          </TextField>
          <TextField label='Icon' sx={{ width: '70%' }}
            value={QRIcon}
            onChange={(e) => handleIconChange(e)}
          >

          </TextField>

          <Button sx={{ alignSelf: 'end' }}
            onClick={async (e) => {
              await handleQRCreate(e)
            }}

          >
            Generate
          </Button>
        </Stack>}
        {/* {QRName} */}
      </Stack>
      {actionError}
    </Container >
  );
};

export default CreateQR;


